import './frontMetier.less';

import { professionOffers } from '../../appAPI';
import { useAsync } from 'react-async-hook';
import { reportError } from '../../appAnalytics';
import { useFrontCountry } from '../../layout/frontContext';
import { ShCurrency, ShShootingType } from '@shoootin/config';
import {
  ShOfferPhotoDTO,
  ShOfferScanDTO,
  ShOfferVideoDTO,
} from '@shoootin/api';

export type MetierPageOffers = {
  photoOffers: ShOfferPhotoDTO[];
  videoOffers: ShOfferVideoDTO[];
  scanOffers: ShOfferScanDTO[];
  currency: ShCurrency;
};

export type MetierPageOffersPhoto = Pick<
  MetierPageOffers,
  'photoOffers' | 'currency'
>;
export type MetierPageOffersVideo = Pick<
  MetierPageOffers,
  'videoOffers' | 'currency'
>;
export type MetierPageOffersScan = Pick<
  MetierPageOffers,
  'scanOffers' | 'currency'
>;

export const useMetierPageOffersLoader = (
  shootingType: ShShootingType,
): MetierPageOffers | undefined => {
  const country = useFrontCountry();
  const offersAsync = useAsync(
    () => professionOffers(country, shootingType),
    [country, shootingType],
    {
      onSuccess: (result) => console.debug('offersAsync success', result),
      onError: reportError,
    },
  );

  // TODO temporary feature switch
  // const enableMetierPageOffers = isDev || useIsTranslateMode();

  if (!offersAsync.result) {
    return;
  }

  const photoOffers = offersAsync.result.offers.filter(
    (offer) => offer.type === 'photo',
  ) as ShOfferPhotoDTO[];
  const videoOffers = offersAsync.result.offers.filter(
    (offer) => offer.type === 'video',
  ) as ShOfferVideoDTO[];
  const scanOffers = offersAsync.result.offers.filter(
    (offer) => offer.type === 'scan',
  ) as ShOfferScanDTO[];

  return {
    photoOffers,
    videoOffers,
    scanOffers,
    currency: offersAsync.result.currency,
  };
};
